import clsx from "clsx";
import type { FC, ReactNode } from "react";
import { useMemo } from "react";
import classes from "./Characteristic.module.scss";

export interface CharacteristicProps {
	text_1: string;
	text_2: string;
	text_3: string;
	text_4: string;
	className?: string;
	children: ReactNode;
}

export interface CharacteristicComponent extends FC<CharacteristicProps> {}

export const Characteristic: CharacteristicComponent = ({
	children,
	text_1,
	text_2,
	text_3,
	text_4,
	className,
}) => {
	const wrapperClassName = useMemo(
		() =>
			clsx(
				classes.wrapper,

				{},
				className
			),
		[className]
	);

	return (
		<div className={wrapperClassName}>
			<div className={classes.content}>
				<h4 className={classes.title}>{children}</h4>
				<span className={classes.text}>{text_1}</span>
				<span className={classes.text}>{text_2}</span>
				<span className={classes.text}>{text_3}</span>
				<span className={classes.text}>{text_4}</span>
			</div>
		</div>
	);
};
